// extracted by mini-css-extract-plugin
export var searchHeader = "_9p-0";
export var searchHeaderDark = "_9p-1";